import { MutationHookOptions, useMutation } from '@apollo/client';

import { REMOVE_PARENT_FROM_CONSULTATION } from './mutations';

export const useRemoveParentFromConsultation = (options?: MutationHookOptions) => useMutation(REMOVE_PARENT_FROM_CONSULTATION, options);
